export default __webpack_public_path__ + "static/1-687f906ce62ebcd7100600e4f67f8b2b.png";